<template>
    <div class="eleccion">
        <div class="eleccion__title">
            <button
                class="align-left"
                @click="$router.push({ name: 'Admin - Elecciones' })"
            >
                <i class="fa fa-arrow-left"></i>
                Volver a elecciones
            </button>
            <h2>Eleccion: {{ eleccion.description }}</h2>
        </div>
        <v-container class="eleccion__container">
            <v-row class="eleccion_dates">
                <v-col><b>Inicio:</b> {{ eleccion.start_date }}</v-col>
                <v-col><b>Fin:</b> {{ eleccion.end_date }}</v-col>
            </v-row>
            <br />
            <br />
            <v-container v-if="!loadingElection" key="election-loaded">
                <h3>
                    Por favor seleccione los archivos requeridos para preparar
                    la elección de {{ eleccion.type }}
                </h3>
                <br />

                <!--
						ALUMNOS START
					-->
                <form
                    :key="updateCounter + '-users-file-form'"
                    class="row mb-5"
                    @submit.prevent="uploadAlumnos"
                >
                    <v-col v-if="!eleccion.users_file || isUsersEditing">
                        <v-row gutter>
                            <v-col>
                                <v-file-input
                                    v-model="csvUsers"
                                    :disabled="isUsersLoading"
                                    :error-messages="csvUsersHeadersError"
                                    accept=".csv"
                                    chips
                                    label="csv users"
                                    show-size
                                    @change="csvSelected('csvUsers')"
                                >
                                </v-file-input>
                            </v-col>
                            <v-col v-if="isUsersEditing" cols="1">
                                <v-btn
                                    :disabled="isUsersLoading"
                                    class="ml-3"
                                    @click="
                                        isUsersEditing = false;
                                        csvUsers = null;
                                    "
                                >
                                    <i class="fa fa-times"></i>
                                    &nbsp; Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-progress-linear
                            v-if="isUsersLoading"
                            :value="usersProgress"
                            color="success"
                            height="25"
                            striped
                        >
                            <template v-slot:default="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                    </v-col>
                    <v-col v-else class="text-left mb-3">
                        <v-btn
                            type="button"
                            @click="downloadCsvFile(eleccion.users_file)"
                        >
                            <i class="fa fa-download"></i> &nbsp; Descargar
                            csv_users.csv
                        </v-btn>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            v-if="!eleccion.users_file || isUsersEditing"
                            key="Enviar-alumnos"
                            :disabled="isUsersLoading"
                            @click="uploadAlumnos"
                        >
                            <i class="fa fa-upload"></i> &nbsp; Enviar Users
                        </v-btn>
                        <v-btn
                            v-else
                            key="Editar-alumnos"
                            :disabled="isUsersLoading"
                            class="ml-3"
                            @click="isUsersEditing = true"
                        >
                            <i class="fa fa-pencil-alt"></i> &nbsp; Editar
                            Alumnos
                        </v-btn>
                    </v-col>
                </form>

                <!--
						ALUMNOS END
					-->

                <!--
						FUNCIONARIOS MESA START
					-->
                <form
                    :key="updateCounter + '-funcMesa-file-form'"
                    class="row mb-5"
                    @submit.prevent="uploadFuncMesa"
                >
                    <v-col
                        v-if="
                            !eleccion.funcionarios_mesa_file ||
                                isFuncMesaEditing
                        "
                    >
                        <v-row gutter>
                            <v-col>
                                <v-file-input
                                    v-model="csvFuncMesa"
                                    :disabled="isFuncMesaLoading"
                                    :error-messages="csvFuncMesaHeadersError"
                                    accept=".csv"
                                    chips
                                    label="csv funcionariosmesa"
                                    show-size
                                    @change="csvSelected('csvFuncMesa')"
                                >
                                </v-file-input>
                            </v-col>

                            <v-col v-if="isFuncMesaEditing" cols="1">
                                <v-btn
                                    :disabled="isFuncMesaLoading"
                                    class="ml-3"
                                    @click="
                                        isFuncMesaEditing = false;
                                        csvFuncMesa = null;
                                    "
                                >
                                    <i class="fa fa-times"></i>
                                    &nbsp; Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-progress-linear
                            v-if="isFuncMesaLoading"
                            :value="funcMesaProgress"
                            color="success"
                            height="25"
                            striped
                        >
                            <template v-slot:default="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                    </v-col>

                    <v-col v-else class="text-left mb-3">
                        <v-btn
                            type="button"
                            @click="
                                downloadCsvFile(eleccion.funcionarios_mesa_file)
                            "
                        >
                            <i class="fa fa-download"></i> &nbsp; Descargar
                            csv_funcionariosmesa.csv
                        </v-btn>
                    </v-col>

                    <v-col class="text-right">
                        <v-btn
                            v-if="
                                !eleccion.funcionarios_mesa_file ||
                                    isFuncMesaEditing
                            "
                            key="Enviar-funcMesa"
                            :disabled="isFuncMesaLoading"
                            @click="uploadFuncMesa"
                        >
                            <i class="fa fa-upload"></i> &nbsp; Enviar
                            Funcionarios mesa
                        </v-btn>
                        <v-btn
                            v-else
                            key="Editar-funcMesa"
                            :disabled="isFuncMesaLoading"
                            class="ml-3"
                            @click="isFuncMesaEditing = true"
                        >
                            <i class="fa fa-pencil-alt"></i> &nbsp; Editar
                            Funcionarios Mesa
                        </v-btn>
                    </v-col>
                </form>

                <!--
						FUNCIONARIOS MESA END
					-->

                <!--
						URES START
					-->

                <form
                    :key="updateCounter + '-ures-file-form'"
                    class="row mb-5"
                    @submit.prevent="uploadUres"
                >
                    <v-col v-if="!eleccion.ures_file || isUresEditing">
                        <v-row gutter>
                            <v-col>
                                <v-file-input
                                    v-model="csvUres"
                                    :error-messages="csvUresHeadersError"
                                    accept=".csv"
                                    chips
                                    label="csv ures"
                                    show-size
                                    @change="csvSelected('csvUres')"
                                >
                                </v-file-input>
                            </v-col>
                            <v-col v-if="isUresEditing" cols="1">
                                <v-btn
                                    :disabled="isUresLoading"
                                    class="ml-3"
                                    @click="
                                        isUresEditing = false;
                                        csvUres = null;
                                    "
                                >
                                    <i class="fa fa-times"></i>
                                    &nbsp; Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-progress-linear
                            v-if="isUresLoading"
                            :value="uresProgress"
                            color="success"
                            height="25"
                            striped
                        >
                            <template v-slot:default="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                    </v-col>
                    <v-col v-else class="text-left mb-3">
                        <v-btn
                            type="button"
                            @click="downloadCsvFile(eleccion.ures_file)"
                        >
                            <i class="fa fa-download"></i> &nbsp; Descargar
                            csv_ures.csv
                        </v-btn>
                    </v-col>

                    <v-col class="text-right">
                        <v-btn
                            v-if="!eleccion.ures_file || isUresEditing"
                            key="Enviar-ures"
                            :disabled="isUresLoading"
                            type="button"
                            @click="uploadUres"
                        >
                            <i class="fa fa-upload"></i> &nbsp; Enviar URES
                        </v-btn>
                        <v-btn
                            v-else
                            key="Editar-ures"
                            :disabled="isUresLoading"
                            class="mb-3"
                            @click="isUresEditing = true"
                        >
                            <i class="fa fa-pencil-alt"></i> &nbsp; Editar URES
                        </v-btn>
                    </v-col>
                </form>

                <!--
						URES END
					-->

                <!--
					   OCG START
					-->

                <form
                    :key="updateCounter + '-ocg-file-form'"
                    class="row mb-5"
                    @submit.prevent="uploadOCG"
                >
                    <v-col v-if="!eleccion.ocg_file || isOCGEditing">
                        <v-row gutter>
                            <v-col>
                                <v-file-input
                                    v-model="csvOCG"
                                    :error-messages="csvOCGHeadersError"
                                    accept=".csv"
                                    chips
                                    label="csv ocg"
                                    show-size
                                    @change="csvSelected('csvOCG')"
                                >
                                </v-file-input>
                            </v-col>
                            <v-col v-if="isOCGEditing" cols="1">
                                <v-btn
                                    :disabled="isOCGLoading"
                                    class="ml-3"
                                    @click="
                                        isOCGEditing = false;
                                        csvOCG = null;
                                    "
                                >
                                    <i class="fa fa-times"></i>
                                    &nbsp; Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-progress-linear
                            v-if="isOCGLoading"
                            :value="ocgProgress"
                            color="success"
                            height="25"
                            striped
                        >
                            <template v-slot:default="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                    </v-col>
                    <v-col v-else class="text-left mb-3">
                        <v-btn
                            type="button"
                            @click="downloadCsvFile(eleccion.ocg_file)"
                        >
                            <i class="fa fa-download"></i> &nbsp; Descargar
                            csv_ocg.csv
                        </v-btn>
                    </v-col>

                    <v-col class="text-right">
                        <v-btn
                            v-if="!eleccion.ocg_file || isOCGEditing"
                            key="Enviar-ocg"
                            :disabled="isOCGLoading"
                            @click="uploadOCG"
                        >
                            <i class="fa fa-upload"></i> &nbsp; Enviar OCG
                        </v-btn>
                        <v-btn
                            v-else
                            key="Editar-ocg"
                            :disabled="isOCGLoading"
                            class="ml-3"
                            @click="isOCGEditing = true"
                        >
                            <i class="fa fa-pencil-alt"></i>
                            &nbsp; Editar OCG
                        </v-btn>
                    </v-col>
                </form>
                <!--
					   OCG END
					-->

                <!--
					   Listado App Voto START
					-->

                <form
                    :key="updateCounter + '-listado-file-form'"
                    class="row mb-5"
                    @submit.prevent="uploadRegistro"
                >
                    <v-col
                        v-if="
                            !eleccion.listado_app_voto_file ||
                                isListadoAppVotoEditing
                        "
                    >
                        <v-row gutter>
                            <v-col>
                                <v-file-input
                                    v-model="csvListadoAppVoto"
                                    :error-messages="
                                        csvListadoAppVotoHeadersError
                                    "
                                    accept=".csv"
                                    chips
                                    label="csv listado app voto"
                                    show-size
                                    @change="csvSelected('csvListadoAppVoto')"
                                >
                                </v-file-input>
                            </v-col>
                            <v-col v-if="isListadoAppVotoEditing" cols="1">
                                <v-btn
                                    :disabled="isListadoAppVotoLoading"
                                    class="ml-3"
                                    @click="
                                        isListadoAppVotoEditing = false;

                                        csvListadoAppVoto = null;
                                    "
                                >
                                    <i class="fa fa-times"></i> &nbsp; Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-progress-linear
                            v-if="isListadoAppVotoLoading"
                            :value="listadoAppVotoProgress"
                            color="success"
                            height="25"
                            striped
                        >
                            <template v-slot:default="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                    </v-col>
                    <v-col v-else class="text-left mb-3">
                        <v-btn
                            type="button"
                            @click="
                                downloadCsvFile(eleccion.listado_app_voto_file)
                            "
                        >
                            <i class="fa fa-download"></i> &nbsp; Descargar
                            csv_listadoappvoto.csv
                        </v-btn>
                    </v-col>

                    <v-col class="text-right">
                        <v-btn
                            v-if="
                                !eleccion.listado_app_voto_file ||
                                    isListadoAppVotoEditing
                            "
                            key="Enviar-registro"
                            :disabled="isListadoAppVotoLoading"
                            type="button"
                            @click="uploadRegistro"
                        >
                            <i class="fa fa-upload"></i> &nbsp; Enviar Listado
                            App Voto
                        </v-btn>
                        <v-btn
                            v-else
                            key="Editar-registro"
                            :disabled="isListadoAppVotoLoading"
                            class="mb-3"
                            @click="isListadoAppVotoEditing = true"
                        >
                            <i class="fa fa-pencil-alt"></i> &nbsp; Editar
                            Listado App Voto
                        </v-btn>
                    </v-col>
                </form>

                <!--
					   Listado App Voto END
					-->

                <!--
					   INT PLANILLA START
					-->

                <form
                    :key="updateCounter + '-planilla-file-form'"
                    class="row mb-5"
                    @submit.prevent="uploadPlanilla"
                >
                    <v-col
                        v-if="
                            !eleccion.int_planilla_file || isIntPlanillaEditing
                        "
                    >
                        <v-row gutter>
                            <v-col>
                                <v-file-input
                                    v-model="csvIntPlanilla"
                                    :error-messages="csvIntPlanillaHeadersError"
                                    accept=".csv"
                                    chips
                                    label="csv int planilla"
                                    show-size
                                    @change="csvSelected('csvIntPlanilla')"
                                >
                                </v-file-input>
                            </v-col>
                            <v-col v-if="isIntPlanillaEditing" cols="1">
                                <v-btn
                                    :disabled="isIntPlanillaLoading"
                                    class="ml-3"
                                    @click="
                                        isIntPlanillaEditing = false;
                                        csvIntPlanilla = null;
                                    "
                                >
                                    <i class="fa fa-times"></i> &nbsp; Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-progress-linear
                            v-if="isIntPlanillaLoading"
                            :value="intPlanillaProgress"
                            color="success"
                            height="25"
                            striped
                        >
                            <template v-slot:default="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                    </v-col>
                    <v-col v-else class="text-left mb-3">
                        <v-btn
                            type="button"
                            @click="downloadCsvFile(eleccion.int_planilla_file)"
                        >
                            <i class="fa fa-download"></i> &nbsp; Descargar
                            csv_intplanilla.csv
                        </v-btn>
                    </v-col>

                    <v-col class="text-right">
                        <v-btn
                            v-if="
                                !eleccion.int_planilla_file ||
                                    isIntPlanillaEditing
                            "
                            key="Enviar-int-planilla"
                            :disabled="isIntPlanillaLoading"
                            type="button"
                            @click="uploadPlanilla"
                        >
                            <i class="fa fa-upload"></i> &nbsp; Enviar INT
                            PLANILLA
                        </v-btn>
                        <v-btn
                            v-else
                            key="Editar-int-planilla"
                            :disabled="isIntPlanillaLoading"
                            class="mb-3"
                            @click="isIntPlanillaEditing = true"
                        >
                            <i class="fa fa-pencil-alt"></i> &nbsp; Editar INT
                            PLANILLA
                        </v-btn>
                    </v-col>
                </form>

                <!--
					   INT PLANILLA END
					-->

                <!--
					   Subcomisiones START
					-->

                <form
                    :key="updateCounter + '-subcomisiones-file-form'"
                    class="row mb-5"
                    @submit.prevent="uploadSubcomisiones"
                >
                    <v-col
                        v-if="
                            !eleccion.subcomisiones_file ||
                                isSubcomisionesEditing
                        "
                    >
                        <v-row gutter>
                            <v-col>
                                <v-file-input
                                    v-model="csvSubcomisiones"
                                    :error-messages="
                                        csvSubcomisionesHeadersError
                                    "
                                    accept=".csv"
                                    chips
                                    label="csv Subcomisiones"
                                    show-size
                                    @change="csvSelected('csvSubcomisiones')"
                                >
                                </v-file-input>
                            </v-col>
                            <v-col v-if="isSubcomisionesEditing" cols="1">
                                <v-btn
                                    :disabled="isSubcomisionesLoading"
                                    class="ml-3"
                                    @click="
                                        isSubcomisionesEditing = false;
                                        csvSubcomisiones = null;
                                    "
                                >
                                    <i class="fa fa-times"></i> &nbsp; Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-progress-linear
                            v-if="isSubcomisionesLoading"
                            :value="subcomisionesProgress"
                            color="success"
                            height="25"
                            striped
                        >
                            <template v-slot:default="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                        </v-progress-linear>
                    </v-col>
                    <v-col v-else class="text-left mb-3">
                        <v-btn
                            type="button"
                            @click="
                                downloadCsvFile(eleccion.subcomisiones_file)
                            "
                        >
                            <i class="fa fa-download"></i> &nbsp; Descargar
                            csv_subcomisiones.csv
                        </v-btn>
                    </v-col>

                    <v-col class="text-right">
                        <v-btn
                            v-if="
                                !eleccion.subcomisiones_file ||
                                    isSubcomisionesEditing
                            "
                            key="Enviar-subcomisiones"
                            :disabled="isSubcomisionesLoading"
                            type="button"
                            @click="uploadSubcomisiones"
                        >
                            <i class="fa fa-upload"></i> &nbsp; Enviar
                            Subcomisiones
                        </v-btn>
                        <v-btn
                            v-else
                            key="Editar-subcomisiones"
                            :disabled="isSubcomisionesLoading"
                            class="mb-3"
                            @click="isSubcomisionesEditing = true"
                        >
                            <i class="fa fa-pencil-alt"></i> &nbsp; Editar
                            Subcomisiones
                        </v-btn>
                    </v-col>
                </form>

                <!--
					   Subcomisiones END
					-->
                <div class="row">
                    <div class="col-12 text-center">
                        <v-btn
                            :disabled="
                                !eleccion.users_file ||
                                    !eleccion.ocg_file ||
                                    !eleccion.ures_file ||
                                    !eleccion.funcionarios_mesa_file ||
                                    !eleccion.listado_app_voto_file ||
                                    !eleccion.subcomisiones_file ||
                                    !eleccion.int_planilla_file
                            "
                            color="success"
                            @click="askConfirm"
                        >
                            <i class="fa fa-save"></i> &nbsp; Aceptar archivos
                        </v-btn>
                    </div>
                </div>
            </v-container>
            <v-row v-else key="loading-election">
                <v-col class="text-center">
                    <i class="fa fa-2x fa-spin fa-spinner"></i>
                </v-col>
            </v-row>

            <v-dialog v-model="saveFiles" max-width="330" persistent>
                <v-card>
                    <v-card-title class="headline">
                        ¿Estás seguro?
                    </v-card-title>
                    <v-card-text>
                        Si continuas la elección '{{ eleccion.description }}'
                        comenzará a configurarse y ya no podrás cambiar los
                        archivos csv
                        <br />
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="!savingFiles"
                            text
                            @click="saveFiles = false"
                        >
                            Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="acceptFiles">
                            <template v-if="!savingFiles">
                                Sí, continuar
                            </template>
                            <span v-else>
                                <i class="fa fa-spinner fa-spin"></i>
                            </span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Papa from 'papaparse';
import _ from 'lodash';

export default {
    data() {
        return {
            savingFiles: false,
            saveFiles: false,
            updateCounter: 0,
            loadingElection: false,
            electionId: this.$route.params.eleccionId,
            // Users
            csvUsers: null,
            csvUsersHeadersError: [],
            isUsersLoading: false,
            usersProgress: 0,
            isUsersEditing: false,
            // funcionariosmesa
            csvFuncMesa: null,
            csvFuncMesaHeadersError: [],
            isFuncMesaLoading: false,
            funcMesaProgress: 0,
            isFuncMesaEditing: false,
            // URES
            csvUres: null,
            csvUresHeadersError: [],
            isUresLoading: false,
            uresProgress: 0,
            isUresEditing: false,
            // OCG
            csvOCG: null,
            csvOCGHeadersError: [],
            isOCGLoading: false,
            ocgProgress: 0,
            isOCGEditing: false,
            // Listado APP VOTO
            csvListadoAppVoto: null,
            csvListadoAppVotoHeadersError: [],
            isListadoAppVotoLoading: false,
            listadoAppVotoProgress: 0,
            isListadoAppVotoEditing: false,

            // Int Planilla
            csvIntPlanilla: null,
            csvIntPlanillaHeadersError: [],
            isIntPlanillaLoading: false,
            intPlanillaProgress: 0,
            isIntPlanillaEditing: false,

            // Subcomisiones
            csvSubcomisiones: null,
            csvSubcomisionesHeadersError: [],
            isSubcomisionesLoading: false,
            subcomisionesProgress: 0,
            isSubcomisionesEditing: false,

            csvAlumnosHeaders: [
                'CODIGO',
                'APELLIDO',
                'NOMBRE',
                'CENTRO',
                'DESC_CENTRO',
                'DIVISION',
                'DESC_DIVISION',
                'TIPO_ELECTOR',
                'EMAIL',
            ],
            csvAcademicosHeaders: [
                'CODIGO',
                'APELLIDO',
                'NOMBRE',
                'CENTRO',
                'DESC_CENTRO',
                'URES_PRED',
                'DESC_URES_PRED',
                'UNIDRESP',
                'DESC_UNIDRESP',
                'TIPO_ELECTOR',
                'EMAIL',
            ],
            csvFuncMesaHeaders: [
                'ELECCION',
                'DESC_ELECCION',
                'URES_PRED',
                'NOMBRE_URES_PRED',
                'URES',
                'DESC_URES',
                'MESA',
                'CODIGO',
                'NOMBRE',
                'TIPO_FUNC',
                'CLASE_FUNC',
                'EMAIL',
            ],
            csvUresHeaders: [
                'ID',
                'URES_URES',
                'URES_DESCRIP',
                'URES_PRED',
                'URES_PRED_DESCRIP',
                'URES_ENTRED',
                'URES_TURES',
            ],
            csvOCGHeaders: ['OCG', 'DESC_OCG', 'ORDER_BY'],
            csvListadoAppVotoHeaders: [
                'MESA',
                'NO_MESA',
                'ELECCION',
                'DESC_ELECCION',
                'URES',
                'DESC_URES',
                'URNA',
                'OCG',
                'DESC_OCG',
                'VOTOS_NULOS',
                'VOTOS_SOBRANTES',
                'ID_PLANILLA',
                'ST_PLAN',
                'ID_COLOR',
                'HEXA_COLOR',
                'COLOR',
                'VOTOS_PLANILLA',
            ],
            csvIntPlanillaHeaders: [
                'ID_PLANILLA',
                'CODIGO',
                'NOMBRE',
                'CLASE_FUNCIONARIO',
                'NO_INTEGRANTE',
                'URES',
                'CONTIENDE_A',
            ],
            csvSubcomisionesHeaders: [
                'login',
                'CLAVE',
                'URES',
                'DESCRIPCION',
                'PREDESESOR',
                'URES_PRED_DESCRIP',
                'ENTIDAD_RED',
                'TIPO_URES',
            ],
        };
    },
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
            eleccion: 'elecciones/eleccion',
        }),
    },
    methods: {
        ...mapActions({
            _getElection: 'elecciones/getEleccion',
            _uploadFile: 'elecciones/uploadFile',
            _saveFiles: 'elecciones/saveFiles',
        }),
        ...mapMutations({
            _setFile: 'elecciones/SET_ELECTION_FILE',
        }),
        getElection() {
            this.loadingElection = true;

            this._getElection(this.electionId)
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => (this.loadingElection = false));
        },
        downloadCsvFile(url) {
            window.open(url, '_blank');
        },
        csvSelected(fileType) {
            if (!this[fileType]) {
                return;
            }

            Papa.parse(this[fileType], {
                step: (row, parser) => {
                    parser.abort();

                    const headersType = `${fileType}Headers`;
                    this.hasCorrectHeaders(row.data, headersType);
                    this.updateCounter++;
                },
            });
        },
        hasCorrectHeaders(sample, type) {
            this[`${type}Error`] = [];
            let headers = this[type];

            if (type === 'csvUsersHeaders') {
                headers =
                    this.eleccion.key_type.toLowerCase() === 'academicos'
                        ? this.csvAcademicosHeaders
                        : this.csvAlumnosHeaders;
            }
            if (!Array.isArray(headers)) {
                return false;
            }

            if (headers.length !== sample.length) {
                this[`${type}Error`] = [
                    `El número de columnas esperado es ${headers.length} pero el archivo contiene ${sample.length}`,
                ];

                return false;
            }

            for (const index in headers) {
                console.log(headers[index], sample[index]);
                if (headers[index] !== sample[index]) {
                    this[`${type}Error`] = [
                        `Por favor verifique que el archivo tenga las columnas en el siguiente orden: \n${headers.join(
                            ', '
                        )}`,
                    ];
                    return false;
                }
            }

            return true;
        },
        uploadAlumnos() {
            if (
                !this.csvUsers ||
                this.isUsersLoading ||
                this.csvUsersHeadersError.length
            ) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.csvUsers);

            this.isUsersLoading = true;
            const data = {
                eleccion_id: this.electionId,
                formData: formData,
                nombre: 'users',
                onUploadProgress: progress => {
                    this.usersProgress = Math.floor(
                        (progress.loaded * 100) / progress.total
                    );
                },
            };

            this._uploadFile(data)
                .then(result => {
                    if (result.data && result.data.uploaded) {
                        const { fileUrl } = result.data;
                        const update = {
                            election_id: this.eleccion.id,
                            file: 'users_file',
                            url: fileUrl,
                        };
                        this._setFile(update);
                    }
                    this.csvUsers = null;
                })
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => {
                    this.isUsersLoading = false;
                    this.isUsersEditing = false;
                });
        },
        uploadFuncMesa() {
            if (
                !this.csvFuncMesa ||
                this.isFuncMesaLoading ||
                this.csvFuncMesaHeadersError.length
            ) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.csvFuncMesa);

            this.isFuncMesaLoading = true;
            this.funcMesaProgress = 0;

            const data = {
                eleccion_id: this.electionId,
                formData,
                nombre: 'funcionarios_mesa',
                onUploadProgress: progress => {
                    this.funcMesaProgress = Math.floor(
                        (progress.loaded * 100) / progress.total
                    );
                },
            };

            this._uploadFile(data)
                .then(result => {
                    if (result.data && result.data.uploaded) {
                        const { fileUrl } = result.data;
                        const update = {
                            election_id: this.eleccion.id,
                            file: 'funcionarios_mesa_file',
                            url: fileUrl,
                        };
                        this._setFile(update);
                    }
                    this.csvFuncMesa = null;
                })
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => {
                    this.isFuncMesaLoading = false;
                    this.isFuncMesaEditing = false;
                });
        },
        uploadUres() {
            if (
                !this.csvUres ||
                this.isUresLoading ||
                this.csvUresHeadersError.length
            ) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.csvUres);

            this.isUresLoading = true;

            const data = {
                eleccion_id: this.electionId,
                formData,
                nombre: 'ures',
                onUploadProgress: progress => {
                    this.uresProgress = Math.floor(
                        (progress.loaded * 100) / progress.total
                    );
                },
            };

            this._uploadFile(data)
                .then(result => {
                    if (result.data && result.data.uploaded) {
                        const { fileUrl } = result.data;
                        const update = {
                            election_id: this.eleccion.id,
                            file: 'ures_file',
                            url: fileUrl,
                        };
                        this._setFile(update);
                    }
                    this.csvUres = null;
                })
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => {
                    this.isUresLoading = false;
                    this.isUresEditing = false;
                });
        },
        uploadOCG() {
            if (
                !this.csvOCG ||
                this.isOCGLoading ||
                this.csvOCGHeadersError.length
            ) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.csvOCG);

            this.isOCGLoading = true;

            const data = {
                eleccion_id: this.electionId,
                formData,
                nombre: 'ocg',
                onUploadProgress: progress => {
                    this.ocgProgress = Math.floor(
                        (progress.loaded * 100) / progress.total
                    );
                },
            };

            this._uploadFile(data)
                .then(result => {
                    if (result.data && result.data.uploaded) {
                        const { fileUrl } = result.data;
                        const update = {
                            election_id: this.eleccion.id,
                            file: 'ocg_file',
                            url: fileUrl,
                        };
                        this._setFile(update);
                    }
                    this.csvOCG = null;
                })
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => {
                    this.isOCGLoading = false;
                    this.isOCGEditing = false;
                });
        },
        uploadRegistro() {
            if (
                !this.csvListadoAppVoto ||
                this.isListadoAppVotoLoading ||
                this.csvListadoAppVotoHeadersError.length
            ) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.csvListadoAppVoto);

            this.isListadoAppVotoLoading = true;

            const data = {
                eleccion_id: this.electionId,
                formData,
                nombre: 'listadoappvoto',
                onUploadProgress: progress => {
                    this.listadoAppVotoProgress = Math.floor(
                        (progress.loaded * 100) / progress.total
                    );
                },
            };

            this._uploadFile(data)
                .then(result => {
                    if (result.data && result.data.uploaded) {
                        const { fileUrl } = result.data;
                        const update = {
                            election_id: this.eleccion.id,
                            file: 'listado_app_voto_file',
                            url: fileUrl,
                        };
                        this._setFile(update);
                    }
                    this.csvListadoAppVoto = null;
                })
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => {
                    this.isListadoAppVotoLoading = false;
                    this.isListadoAppVotoEditing = false;
                });
        },
        uploadPlanilla() {
            if (
                !this.csvIntPlanilla ||
                this.isIntPlanillaLoading ||
                this.csvIntPlanillaHeadersError.length
            ) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.csvIntPlanilla);

            this.isIntPlanillaLoading = true;

            const data = {
                eleccion_id: this.electionId,
                formData,
                nombre: 'intplanilla',
                onUploadProgress: progress => {
                    this.intPlanillaProgress = Math.floor(
                        (progress.loaded * 100) / progress.total
                    );
                },
            };

            this._uploadFile(data)
                .then(result => {
                    if (result.data && result.data.uploaded) {
                        const { fileUrl } = result.data;
                        const update = {
                            election_id: this.eleccion.id,
                            file: 'int_planilla_file',
                            url: fileUrl,
                        };

                        this._setFile(update);
                    }
                    this.csvIntPlanilla = null;
                })
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => {
                    this.isIntPlanillaLoading = false;
                    this.isIntPlanillaEditing = false;
                });
        },
        uploadSubcomisiones() {
            if (
                !this.csvSubcomisiones ||
                this.isSubcomisionesLoading ||
                this.csvSubcomisionesHeadersError.length
            ) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.csvSubcomisiones);

            this.isSubcomisionesLoading = true;

            const data = {
                eleccion_id: this.electionId,
                formData,
                nombre: 'subcomisiones',
                onUploadProgress: progress => {
                    this.subcomisionesProgress = Math.floor(
                        (progress.loaded * 100) / progress.total
                    );
                },
            };

            this._uploadFile(data)
                .then(result => {
                    if (result.data && result.data.uploaded) {
                        const { fileUrl } = result.data;
                        const update = {
                            election_id: this.eleccion.id,
                            file: 'subcomisiones_file',
                            url: fileUrl,
                        };
                        this._setFile(update);
                    }
                    this.csvSub = null;
                })
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => {
                    this.isSubcomisionesLoading = false;
                    this.isSubcomisionesEditing = false;
                });
        },

        askConfirm() {
            const {
                users_file,
                ocg_file,
                ures_file,
                funcionarios_mesa_file,
                listado_app_voto_file,
                int_planilla_file,
                subcomisiones_file,
            } = this.eleccion;

            if (
                !users_file ||
                !ocg_file ||
                !ocg_file ||
                !ures_file ||
                !funcionarios_mesa_file ||
                !listado_app_voto_file ||
                !int_planilla_file ||
                !subcomisiones_file
            ) {
                return;
            }
            this.saveFiles = true;
        },
        acceptFiles() {
            if (this.savingFiles) {
                return;
            }
            this.savingFiles = true;
            this._saveFiles({ election_id: this.eleccion.id })
                .then(result => {
                    console.log(result);
                    if (_.get(result, 'data.reason') === 'not_waiting') {
                        this.$store.dispatch(
                            'errorMessage',
                            `No es posible modificar el status de la elección`
                        );
                        return;
                    }

                    if (_.get(result, 'data.started')) {
                        this.$router.push({ name: 'Admin - Elecciones' });
                        return;
                    }

                    this.$store.dispatch(
                        'errorMessage',
                        `Ha ocurrido un problema al actualizar la elección`
                    );
                })
                .catch(error => this.$store.dispatch('errorMessage', error))
                .finally(() => {
                    this.savingFiles = false;

                    this.saveFiles = false;
                });
        },
    },
    created() {
        this.getElection();
    },
};
</script>

<style scoped lang="scss">
.eleccion {
    margin: 0% 3% 0;

    &__title {
        padding: 10px;
        text-align: left;

        button {
            font-size: 1.5em;
        }
    }

    &__container {
        border-radius: 10px;
        background-color: white;
        min-height: 300px;
        padding: 20px;
        margin-bottom: 3%;
    }
}
</style>
